module.exports = __webpack_public_path__ + "img/home.2620b910.svg";